import * as actionTypes from '../../action/taskdetails/TaskDetails'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: '',
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_TASKDETAILS_FETCH:
            return {
                ...state,
                taskFetching: true
            };
        case actionTypes.GET_TASKDETAILS_SUCCESS :
            return {
                ...state,
                taskFetching: false,
                error: false,
                taskDetails: action.payload
            };
        
        case actionTypes.GET_TASKDETAILS_FAILURE :
            return {
                ...state,
                taskFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_TASKDETAILS_MESSAGE:
            return {
                ...state,
                taskFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;